export const videos = [
  {
    id: "presentation",
    title: "CKZiU Wyrzysk - Prezentacja",
    description: "Wszystko o Nas w jednym miejscu.",
    youtubeId: "vt6Ocw8iHfQ",
  },
  {
    id: "offer",
    title: "CKZiU Wyrzysk - oferta edukacyjna",
    description:
      "Zapraszamy do zapoznania się z ofertą edukacyjną CKZiU w Wyrzysku. Dołącz do nas.",
    youtubeId: "hR4CHdFe9WM",
  },
  {
    id: "eJBl1UHagcg",
    title:
      "Technik Informatyk Technik Programista",
    description:
      "Chcesz kształcić się z nami? Dołącz do nas, a nie pożałujesz!",
    youtubeId: "eJBl1UHagcg",
  },
  {
    id: "cs-v1",
    title: "Wyrzysk LAN CS vol.1",
    description: "Rozgrywki CS 04.12.2019 vol.1",
    youtubeId: "3kiadvmsGno",
  },
  {
    id: "cs-v2",
    title: "Wyrzysk LAN CS vol.2",
    description: "Rozgrywki CS 04.12.2019 vol.2",
    youtubeId: "KtN7FGFeWSg",
  },
  {
    id: "cs-rel",
    title: "Wyrzysk LAN 2019 - FOTORELACJA",
    description: "Rozgrywki CS 04.12.2019",
    youtubeId: "l0t8qDaJqCU",
  },
  {
    id: "advert",
    title: "Film reklamujący CKZiU Wyrzysk",
    description: "24 mar 2014",
    youtubeId: "Rr-mnwcJgNw",
  },
  {
    id: "school-2015",
    title:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku 2015",
    description:
      "Prezentacja z życia wyrzyskiej szkoły ponadgimnazjalnej.",
    youtubeId: "bt0cctWcjX8",
  }
];